import camelcaseKeys from "camelcase-keys";
import {
  onCompleteMediaContent,
  onGetDetailMediaContent,
  onUploadMediaContent,
} from "services/apis/mediaContent";

const {
  createSlice,
  createAsyncThunk,
  createSelector,
} = require("@reduxjs/toolkit");

export const doUploadMediaContent = createAsyncThunk(
  "mediaContent/doUploadMediaContent",
  async params => {
    const result = await onUploadMediaContent(params);
    console.log("result", result);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doGetDetailMediaContent = createAsyncThunk(
  "mediaContent/doGetDetailMediaContent",
  async params => {
    const result = await onGetDetailMediaContent(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doCompleteMediaContent = createAsyncThunk(
  "mediaContent/doCompleteMediaContent",
  async params => {
    const result = await onCompleteMediaContent(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

const initialState = {
  isSaving: false,
  mediaContentDetail: {},
};

const slice = createSlice({
  name: "mediaContent",
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [doUploadMediaContent.pending]: state => {
      state.isSaving = true;
    },
    [doUploadMediaContent.fulfilled]: state => {
      state.isSaving = false;
    },
    [doUploadMediaContent.rejected]: state => {
      state.isSaving = false;
    },
    [doGetDetailMediaContent.fulfilled]: (state, action) => {
      state.mediaContentDetail = action.payload;
    },
  },
});

const { reducer } = slice;

export default reducer;

export const isSavingUpload = createSelector(
  state => state.mediaContent.isSaving,
  isSaving => isSaving
);
